module.exports = __webpack_public_path__ + "img/02-illu-matome2021.8437077d.jpg";